import ToggleItem, { ToggleItemProps } from '../../../../forms/ToggleItem'
import { ColorEnum } from '@/constants/color'
import { Collapsible } from '@/features/ui/components/Collapsible'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

interface NotificationToggleItemProps extends ToggleItemProps {
    sound: boolean
    onSoundChange: (val: boolean) => void
}

const NotificationToggleItem: FC<NotificationToggleItemProps> = ({
    checked,
    sound,
    onSoundChange,
    ...rest
}) => {
    const { t } = useTranslation()

    return (
        <View style={styles.container}>
            <ToggleItem checked={checked} {...rest} />
            <Collapsible
                open={checked}
                contentStyle={styles.expandedContent}
                disabled={rest.disabled}
                stayExpandedWhenDisabled
            >
                <ToggleItem
                    description={t('settings.notifications.soundNotification')}
                    checked={sound}
                    onChange={onSoundChange}
                    disabled={rest.disabled}
                />
            </Collapsible>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        borderBottomColor: ColorEnum.GRAY_200,
        borderBottomWidth: 1,
        paddingTop: 16,
    },
    expandedContent: {
        paddingLeft: 24,
    },
})

export default NotificationToggleItem
